import { hourOf } from "../demo-v2/clock.js";
import { shortName } from "../demo-v2/photos.js";
import { SEED, seedSrc } from "../demo-v2/seed.js";

export interface WallPhoto {
  readonly id: string;
  readonly author: string;
  readonly at: number;
  readonly small: string;
  readonly large: string;
}

export const PHOTOS: readonly WallPhoto[] = SEED.map((seed) => ({
  id: seed.id,
  author: seed.author,
  at: seed.at,
  small: seedSrc(seed.id, "s"),
  large: seedSrc(seed.id, "l"),
}));

export const COVER = seedSrc("c01", "l");

export function photoById(id: string): WallPhoto {
  return PHOTOS.find((photo) => photo.id === id) ?? (PHOTOS[0] as WallPhoto);
}

export function rotate<T>(list: readonly T[], start: number): T[] {
  if (list.length === 0) {
    return [];
  }
  const offset = ((start % list.length) + list.length) % list.length;
  return [...list.slice(offset), ...list.slice(0, offset)];
}

export interface HourShelf {
  readonly hour: number;
  readonly photos: readonly WallPhoto[];
}

export function shelves(photos: readonly WallPhoto[]): HourShelf[] {
  const byHour = new Map<number, WallPhoto[]>();
  for (const photo of photos) {
    const hour = hourOf(photo.at);
    byHour.set(hour, [...(byHour.get(hour) ?? []), photo]);
  }
  return [...byHour.entries()].map(([hour, list]) => ({ hour, photos: list }));
}

export { shortName };
